import type { Locale } from '@shop/shared';

// The language of the page being shown, read by the API client so every storefront request
// asks for the right translation. Kept in its own module to avoid an import cycle.
let requestLocale: Locale = 'en';

export const setRequestLocale = (locale: Locale) => {
  requestLocale = locale;
};
export const getRequestLocale = () => requestLocale;
